"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
var react_1 = require("@emotion/react");
var icons_1 = require("../../../icons");
var Tooltip_1 = __importDefault(require("../../Tooltip"));
var styles_1 = require("./styles");
var AvatarAdd = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'md' : _b, addButtonTooltip = _a.addButtonTooltip, _c = _a.tooltipPlacement, tooltipPlacement = _c === void 0 ? 'right' : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, onClick = _a.onClick;
    var styles = styles_1.getAvatarAddBtnStyles(size);
    return (react_1.jsx(Tooltip_1.default, { overlay: addButtonTooltip, placement: tooltipPlacement },
        react_1.jsx("button", { css: styles.root, onClick: onClick, disabled: disabled },
            react_1.jsx(icons_1.Plus, { size: styles_1.sizesMap[size].font }))));
};
exports.default = AvatarAdd;
